import { useParams } from 'react-router'

interface TicketSizeRouteParams {
    estate: string;
    ticketSize: string;
}

export default function useTicketSizeParams() {
    const { estate, ticketSize } = useParams<TicketSizeRouteParams>()

    return {
        estate,
        ticketSizeId: ticketSize ? parseInt(ticketSize, 10) : undefined,
    }
}
